export const PREFERRED_CHANNEL_OPTIONS = {
  EMAIL: 'Email',
  SMS: 'SMS',
  AUTOMATED_CALL: 'Automated Call',
}

export const GENDER_LIST = {
  MALE: 'Male',
  FEMALE: 'Female',
  OTHERS: 'Others',
}

export const HEADERS_IMPORT_CSV_FILE = [
  {
    header: 'unique_id',
    label: 'subscriber.label.uniqueId',
    required: false,
  },
  {
    header: 'first_name',
    label: 'firstName.label',
    required: true,
  },
  {
    header: 'last_name',
    label: 'lastName.label',
    required: true,
  },
  {
    header: 'email',
    label: 'email.address.label',
    required: true,
    errorKey: 'emailOrPhone',
  },
  {
    header: 'country_code',
    label: 'subscriber.label.countryCode',
    required: true,
  },
  {
    header: 'phone_number',
    label: 'subscriber.label.phoneNumber',
    required: true,
    errorKey: 'emailOrPhone',
  },
  {
    header: 'date_of_birth',
    label: 'subscriber.label.dateOfBirth',
    required: false,
  },
  {
    header: 'gender',
    label: 'subscriber.label.gender',
    options: [GENDER_LIST.MALE, GENDER_LIST.FEMALE, GENDER_LIST.OTHERS],
    required: false,
  },
  {
    header: 'preferred_contact_method',
    label: 'subscriber.label.preferredContactMethod',
    options: [
      PREFERRED_CHANNEL_OPTIONS.EMAIL,
      PREFERRED_CHANNEL_OPTIONS.SMS,
      PREFERRED_CHANNEL_OPTIONS.AUTOMATED_CALL,
    ],
    required: false,
  },
  {
    header: 'preferred_language',
    label: 'subscriber.label.language',
    options: [],
    required: false,
  },
  {
    header: 'contact_permission',
    label: 'subscriber.label.contactPermission',
    required: false,
    options: ['Yes', 'No'],
  },
  {
    header: 'secondary_email',
    label: 'subscriber.label.secondaryEmail',
    required: false,
  },
  {
    header: 'secondary_phone_number_country_code',
    label: 'subscriber.label.secondaryPhoneNumberCountryCode',
    required: false,
  },
  {
    header: 'secondary_phone_number',
    label: 'subscriber.label.secondaryPhoneNumber',
    required: false,
  },
  {
    header: 'automated_call_country_code',
    label: 'subscriber.label.automatedCallCountryCode',
    required: false,
    errorKey: 'automated_call_duplication',
  },
  {
    header: 'automated_call_number',
    label: 'subscriber.label.automatedCallNumber',
    required: false,
    errorKey: 'automated_call_duplication',
  },
  {
    header: 'passport_number',
    label: 'subscriber.label.passportNumber',
    required: false,
  },
  {
    header: 'passport_country',
    label: 'subscriber.label.passportCountry',
    required: false,
  },
  {
    header: 'passport_expiration_date',
    label: 'subscriber.label.passportExpirationDate',
    required: false,
  },
  {
    header: 'nationality',
    label: 'subscriber.label.nationality',
    required: false,
  },
  {
    header: 'job_role',
    label: 'subscriber.label.jobRole',
    required: false,
    options: [],
  },
  {
    header: 'job_department',
    label: 'subscriber.label.jobDepartment',
    required: false,
  },
  {
    header: 'organization_company',
    label: 'subscriber.label.organizationCompany',
    required: false,
  },
  {
    header: 'emergency_contact_name',
    label: 'subscriber.label.emergencyContactName',
    required: false,
  },
  {
    header: 'emergency_contact_relationship',
    label: 'subscriber.label.emergencyContactRelationship',
    required: false,
  },
  {
    header: 'emergency_contact_phone_country_code',
    label: 'subscriber.label.emergencyContactPhoneCountryCode',
    required: false,
  },
  {
    header: 'emergency_contact_phone',
    label: 'subscriber.label.emergencyContactPhone',
    required: false,
  },
  {
    header: 'emergency_contact_email',
    label: 'subscriber.label.emergencyContactEmail',
    required: false,
  },
  {
    header: 'address_line_1',
    label: 'subscriber.label.addressLine1',
    required: false,
  },

  {
    header: 'address_line_2',
    label: 'subscriber.label.addressLine2',
    required: false,
  },
  {
    header: 'city',
    label: 'subscriber.label.city',
    required: false,
  },
  {
    header: 'state_province_region',
    label: 'subscriber.label.stateProvinceRegion',
    required: false,
  },
  {
    header: 'postal_zip_code',
    label: 'subscriber.label.postalZipCode',
    required: false,
  },
  {
    header: 'country',
    label: 'subscriber.label.country',
    required: false,
  },
  {
    header: 'facebook_profile',
    label: 'subscriber.label.facebookProfile',
    required: false,
  },
  {
    header: 'twitter_profile',
    label: 'subscriber.label.twitterProfile',
    required: false,
  },
  {
    header: 'linkedin_profile',
    label: 'subscriber.label.linkedinProfile',
    required: false,
  },
  {
    header: 'line',
    label: 'subscriber.label.line',
    required: false,
  },
  {
    header: 'notes',
    label: 'subscriber.label.notes',
    required: false,
  },
]

export const VALIDATE_PROCESS_TYPE = 'validate'
export const IMPORT_PROCESS_TYPE = 'import'

export const SCHOOL_IMPORT_STATUS_STARTED = 'started'
export const SCHOOL_IMPORT_STATUS_COMPLETED = 'completed'
export const SCHOOL_IMPORT_STATUS_FAILED = 'failed'
export const SCHOOL_IMPORT_STATUS_CENCELED = 'canceled'

export const SCHOOL_IMPORT_STATUS_CANSEL = 2

export const SocketEvent = {
  IMPORT_PROCESS_PERCENTAGE: 'importProcessPercentage',
  SUBSCRIBERS_DELETION_STATUS: 'subscribersDeletionStatus',
  SUBSCRIBERS_SCHOOL_IMPORT_STATUS: 'subscribersSchoolImportStatus',
}

export const CANCEL_IMPORT_CSV = 1
export const CANCEL_SIS_IMPORT = 2

export const MAX_CSV_SIZE = 500 // MB

export const MSG_DUPLICATE_UNIQUE_ID =
  'Duplicate unique ID detected. Each subscriber should have a unique identifier.'
export const MSG_DUPLICATE_AUTOMATED_CALL_NUMBER =
  'Duplicate automated call number detected.'
export const MSG_DUPLICATE_ENTRIES =
  'Duplicate email or phone number detected. Each subscriber should have a unique email or phone number.'

export const dateColumns = ['date_of_birth', 'passport_expiration_date']

export const keysToLowercase = [
  'preferred_contact_method',
  'gender',
  'contact_permission',
]
